export const ACCOUNT_TYPES = {
  CASH: 'CASH',
  BANK: 'BANK',
  CREDIT: 'CREDIT',
  GOAL: 'GOAL',
  INVESTMENT: 'INVESTMENT',
  LOAN: 'LOAN',
};

export const BANKING_ACCOUNT_TYPES = [
  'OTHER_ASSET', 'BANK', 'CREDIT', 'LOAN', 'CASH', 'OTHER_LIABILITY', 'REAL_ESTATE', 'VEHICLE',
];
